import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, map, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { Actions } from 'Flux/Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { addMessage } from 'Flux/Slice/Application/ApplicationSlice.js'
import { errorMessage } from 'Model/Message/IMessage.js'
import type { Epic } from 'Flux/index.js'

export const UpdateSamplePoolLabelEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.updateSamplePoolLabelRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.updateSamplePoolLabel(action.payload, state.authentication.user).pipe(
        map((response) =>
          order.updateSamplePoolLabelSuccess({
            orderId: action.payload.orderId,
            poolId: action.payload.poolId,
            label: response.label,
            version: response.version
          })
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(
              order.updateSamplePoolLabelFailure({ error }),
              addMessage(
                errorMessage(
                  (error as { status?: number })?.status === 409
                    ? 'The pool was changed in the meantime. Reload the order and rename it again.'
                    : 'Could not rename the pool'
                )
              )
            )
          })
        )
      )
    )
  )
